import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-plan-details',
  templateUrl: './plan-details.component.html',
  styleUrls: ['./plan-details.component.scss']
})
export class PlanDetailsComponent implements OnInit {
  @Input() subscriptionPlan;
  @Input() cameraPlan;
  @Input() isCameraPlanEnabled;
  constructor() { }

  ngOnInit() {
  }

}
